import { apiSlice } from "../../../api/ApiService";

const getPatientDetailApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientDetails: builder.query({
      query: ({ accessToken, patientCaseId }: { accessToken: string | null, patientCaseId: number }) => ({
        url: `/api/v1/Administration/${patientCaseId}/manage-patient`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),   
      providesTags: [{ type: "PatientList" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientDetailsQuery } = getPatientDetailApi;
export default getPatientDetailApi;
